import { Slide } from "@jelly/lesson";

const principle: Slide = {
  title: "Introduction",
  layout: {
    type: "customCase040101",
    options: {
      description:
        "This case demonstrates the design of a floor standing speaker system. The different stages of the enclosure design are detailed below. Questions will also be asked along the way.",
      steps: [
        "Presentation of the system requirements",
        "Characterization of the drivers and bass reflex tuning",
        "Measurement of the drivers’ on-axis pressure level",
        "Design of the filters",
        "Measurement of the complete system",
      ],
    },
  },
};

export default principle;
